//base url
// export const BASE_URL = "http://3.7.129.129/fc-core";
// export const BASE_URL = "https://api.scalent.in/fc-core";
// export const BASE_URL = "http://localhost:9025/fc-core";
export const BASE_URL = "https://api.falcon-co.com/fc-core";

// login API
export const LOGIN = `${BASE_URL}/login`;

// logout
export const LOGOUT = `${BASE_URL}/logout`;

//role
export const ROLE_LIST = `${BASE_URL}/role/list`;

//user
export const USER = `${BASE_URL}/user/`;
export const USERS_LIST = `${BASE_URL}/user/list`;

//categories
export const CATEGORY_LIST = `${BASE_URL}/category/`;

//manufacturer
export const MANUFACTURER = `${BASE_URL}/manufacturer/`;
export const MANUFACTURER_LIST = `${BASE_URL}/manufacturer/list`;

//product-categories
export const PRODUCT_CATEGORIES = `${BASE_URL}/product-category/`;

export const PRODUCT_CATEGORIES_LIST = `${BASE_URL}/product-category/list`;

//customers
export const CUSTOMER = `${BASE_URL}/customer/`;
export const CUSTOMER_LIST = `${BASE_URL}/customer/list`;

//payment term in customers
export const PAYMENT_TERM_LIST = `${BASE_URL}/payment-term/list`;

//Job Type
export const JOB_TYPE = `${BASE_URL}/job-type/`;
export const JOB_TYPE_LIST = `${BASE_URL}/job-type/list`;

//technicians
export const TECHNICIANS = `${BASE_URL}/technician/`;
export const TECHNICIANS_LIST = `${BASE_URL}/technician/list`;

//region
// export const REGION_LIST =`${BASE_URL}/region/list`;

//specialization
export const SPECIALIZATION_LIST = `${BASE_URL}/specialization/list`;
//customer service location
export const CUSTOMER_LOCATION = `${BASE_URL}/customer-location/`;
export const CUSTOMER_LOCATION_LIST = `${BASE_URL}/customer-location/list`;

//customer service location's region,city and country
export const REGION_LIST = `${BASE_URL}/region/list`;
export const CITY_LIST = `${BASE_URL}/city/list`;
export const COUNTRY_LIST = `${BASE_URL}/country/list`;

//customer discount
export const CUSTOMER_DISCOUNT = `${BASE_URL}/customer-discount/`;
export const CUSTOMER_DISCOUNT_LIST = `${BASE_URL}/customer-discount/list`;

//coustomer equipments
export const CUSTOMER_EQUIPMENT = `${BASE_URL}/customer-equipment/`;
export const CUSTOMER_EQUIPMENT_LIST = `${BASE_URL}/customer-equipment/list`;

//product
export const PRODUCT = `${BASE_URL}/product/`;
export const PRODUCT_LIST = `${BASE_URL}/product/list`;
//Services
export const SERVICE = `${BASE_URL}/service/`;
export const SERVICE_LIST = `${BASE_URL}/service/list`;

//technician availability
export const TECHNICIAN_AVAILABILITY = `${BASE_URL}/technician-availability/`;

//timeSlot
export const TIME_SLOT = `${BASE_URL}/time-slot/list`;
// Spare Parts
export const SPARE_PARTS = `${BASE_URL}/spare-part/`;
export const SPARE_PARTS_LIST = `${BASE_URL}/spare-part/list`;
//job
export const JOB = `${BASE_URL}/job/`;
export const JOB_LIST = `${BASE_URL}/job/list`;

//forgot password
export const FORGET_PASSWORD = `${BASE_URL}/forget`;

//validate uuid:
export const VALIDATE_UUID_LINK = `${BASE_URL}/validate-link/`;

//reset-password
export const RESET_PASSWORD = `${BASE_URL}/reset-password`;

//technician leave
export const TECHNICIAN_LEAVE = `${BASE_URL}/technician-leave/`;
export const TECHNICIAN_LEAVE_LIST = `${BASE_URL}/technician-leave/list/`;

//job timeline
export const JOB_TIME_LINE = `${BASE_URL}/job-time-line/`;
//resend email invite to user/customer
export const RESEND_EMAIL_INVITE = `${BASE_URL}/user/resend-email/`;

//upload job files
export const UPLOAD_JOB_FILES = `${BASE_URL}/job-media/`;

//quotation history
export const QUOTATION_HISTORY = `${BASE_URL}/quotation/history/`;

//quotation download
export const QUOTATION_DOWNLOAD = `${BASE_URL}/quotation/download/`;

// job logs
export const JOB_LOGS = `${BASE_URL}/job-log/list/`;

// Technical report
export const TECHNICAL_REPORT = `${BASE_URL}/technical-report/`;
export const TECHNICAL_REPORT_MEDIA = `${BASE_URL}/technical-report/media/`;

//available date for technician
export const AVAILABLE_TECH_DATES = `${BASE_URL}/job/available-dates/technician/`;

//reschedule the job
export const RESCHEDULE_JOB = `${BASE_URL}/job/reschedule/`;
// job feedback
export const JOB_FEEDBACK = `${BASE_URL}/job-feedback/`;

//export csv file of product
export const EXPORT_PRODUCT_CSV = `${BASE_URL}/product/export`;
//quotation
export const QUOTATION = `${BASE_URL}/quotation/`;
export const QUOTATION_LIST = `${BASE_URL}/quotation/detail/`;
export const QUOTATION_DISCOUNT = `${BASE_URL}/quotation/discount`;
export const REQUOTE_QUOTATION = `${BASE_URL}/quotation/requote`;
export const QUOTATION_REQUOTE_LIST = `${BASE_URL}/reason/list`;

export const VALIDATE_QUOTATION_UUID = `${BASE_URL}/quotation/validate`;
export const APPROVE_AND_REJECT_QUOTATION = `${BASE_URL}/quotation/review`;
export const RECORD_BANK_TRANSFER = `${BASE_URL}/quotation/record-bank-transfer`;

//Request Parts List
export const REQUEST_PARTS_LIST = `${BASE_URL}/part-request/list`;
export const GET_REQUESTED_LIST_BY_ID = `${BASE_URL}/part-request`;
export const UPDATE_REQUESTED_PARTS_STATUS = `${BASE_URL}/part-request/update-status`;
export const GET_PARTS_NOTES_BY_JOB_ID = `${BASE_URL}/job/parts-note`;
export const UPDATE_PARTS_NOTES_BY_JOB_ID = `${BASE_URL}/job/parts-note`;

// Cancel Job
export const CANCEL_JOB = `${BASE_URL}/job/cancel`;

//Complete Job
export const COMPLETE_JOB = `${BASE_URL}/job/complete`;

// Equipment Manual
export const EQUIPMENT_MANUAL = `${BASE_URL}/job/manual`;

// Job Media
export const GET_JOB_MEDIA = `${BASE_URL}/job-media/list`;

// Service History
export const CUSTOMER_SERVICE_HISTORY = `${BASE_URL}/job/service/history/location`;

//Job Completed Rework
export const JOB_COMPLETED_OR_REWORK = `${BASE_URL}/job/completed-rework`;

//Download Job Report
export const DOWNLOAD_JOB_REPORT = `${BASE_URL}/job/download-report`;

//Export Parts Requested CSV
export const EXPORT_PARTS_REQUESTED_CSV = `${BASE_URL}/part-request/export`;

//Continue Job
export const CONTINUE_JOB = `${BASE_URL}/job/continue`;

// Job Under Warrenty
export const JOB_UNDER_WARRENTY = `${BASE_URL}/job/warranty`;

// Admin Note
export const ADMIN_NOTE = `${BASE_URL}/job/admin-note`;

//assign technician
export const ASSIGN_TECHNICIAN = `${BASE_URL}/job/assign-new-technician`;

// Get CheckoutId
export const GENERATE_CHECKOUT_ID = `${BASE_URL}/payments/create-checkout`;

//Download Payment Receipt
export const DOWNLOAD_PAYMENT_RECEIPT = `${BASE_URL}/payments/receipt`;

//Get Payment Status
export const GET_PAYMENT_STATUS = `${BASE_URL}/payments/verify`;

// edit sales order number
export const EDIT_SALES_ORDER_NUMBER = `${BASE_URL}/job/update-sales-order`;

// download job media
export const DOWNLOAD_JOB_MEDIA = `${BASE_URL}/job-media/download`;

// download product manual
export const DOWNLOAD_PRODUCT_MANUAL = `${BASE_URL}/product/download-manual`;

// download equipment invoice
export const DOWNLOAD_EQUIPMENT_INVOICE = `${BASE_URL}/customer-equipment/download-invoice`;

// job payment details
export const PAYMENT_DETAILS = `${BASE_URL}/payment/list`;

// reopen job
export const REOPEN_JOB = `${BASE_URL}/job/reopen`;

// internal monitoring
export const INTERNAL_MONITORING = `${BASE_URL}/job/internal-tracking`;

//Export jobs CSV
export const EXPORT_JOBS_CSV = `${BASE_URL}/job/export`;

//Export services CSV
export const EXPORT_SERVICES_CSV = `${BASE_URL}/service/export`;

//Export spare parts CSV
export const EXPORT_SPARE_PARTS_CSV = `${BASE_URL}/spare-part/export`;

//assign location to sub user
export const ASSIGN_LOCATION_SUB_USER = `${BASE_URL}/user-location/`;

//assign location to sub user
export const DOWNLOAD_BULK_WORK_ORDER_REPORTS = `${BASE_URL}/job/download-bulk-report`;

//Dashboard Job Status Count
export const DASHBOARD_JOB_STATUS = `${BASE_URL}/admin/dashboard/job-status-count`;

//Dashboard Payment Status Count
export const DASHBOARD_PAYMENT_STATUS = `${BASE_URL}/admin/dashboard/payment-status-count`;

//Dashboard Quotation Status Count
export const DASHBOARD_QUOTATION_STATUS_COUNT = `${BASE_URL}/admin/dashboard/quotation-status-count`;

//Dashboard Quotation Status Count
export const DASHBOARD_SPARE_PARTS_STATUS_COUNT = `${BASE_URL}/admin/dashboard/spare-part-status-count`;

//Dashboard Quotation Requested for Approval
export const DASHBOARD_QUOTATION_REQUESTED_FOR_APPROVAL = `${BASE_URL}/admin/dashboard/quotation-requested-for-approval`;

//Dashboard Spare Parts Ready for Pickup
export const DASHBOARD_SPARE_PARTS_READY_FOR_PICKUP =  `${BASE_URL}/admin/dashboard/job-ready-for-pickup`;

//Dashboard Odoo Summary Data
export const DASHBOARD_ODOO_SUMMARY = `${BASE_URL}/admin/dashboard/odoo-sync-summary`; 

//Dashboard Work order line chart
export const DASHBOARD_WORK_ORDER_LINE_CHART = `${BASE_URL}/admin/dashboard/work-order-line-chart`;

//Dashboard Action Required Data
export const DASHBOARD_ACTION_REQUIRED = `${BASE_URL}/admin/dashboard/action-required`;

// Dashboard reports
export const DASHBOARD_REPORT = `${BASE_URL}/admin/dashboard/report`;
export const DASHBOARD_REPORT_EXPORT = `${BASE_URL}/admin/dashboard/report-export`;

//Dashboard Odoo list 
export const DASHBOARD_ODOO_SYNC_SUMMARY_MANUFACTURAR = `${BASE_URL}/admin/dashboard/odoo-sync/manufacturer/not-synced`;

//Dashboard Odoo list 
export const DASHBOARD_ODOO_SYNC_SUMMARY_CUSTOMERS = `${BASE_URL}/admin/dashboard/odoo-sync/customer/not-synced`;

//Dashboard Odoo list 
export const DASHBOARD_ODOO_SYNC_SUMMARY_SPARE_PARTS = `${BASE_URL}/admin/dashboard/odoo-sync/spare-part/not-synced`;

//Dashboard Odoo list 
export const DASHBOARD_ODOO_SYNC_SUMMARY_SERVICES = `${BASE_URL}/admin/dashboard/odoo-sync/service/not-synced`;

//Dashboard Odoo list 
export const DASHBOARD_ODOO_SYNC_SUMMARY_QUOTATIONS = `${BASE_URL}/admin/dashboard/odoo-sync/quotation/not-synced`;

//Dashboard Action Required List
export const DASHBOARD_ACTION_REQUIRED_LIST = `${BASE_URL}/admin/dashboard/name/action-required`;

//Dashboard Payment Status Failed List
export const DASHBOARD_PAYMENT_STATUS_FAILED_AND_SUCCESS_LIST = `${BASE_URL}/admin/dashboard/payment-status`;

export const EXPORT_CSV = `${BASE_URL}/admin/dashboard/export-csv`;

export const ODOO_SALES = `${BASE_URL}/admin/dashboard/odoo/sales`

export const ODOO_QUOTATION_COUNT = `${BASE_URL}/admin/dashboard/odoo/quotation`


export const DOWNLOAD_JOB_BULK_REPORTS = `${BASE_URL}/job/bulk-reports`;

//Download Work Order Quotation Items CSV
export const DOWNLOAD_JOB_QUOTATION_ITEMS_CSV = `${BASE_URL}/job/download-job-quotation-items`;

export const JOB_BULK_REPORTS_EXPORT_LIST = `${BASE_URL}/job/bulk-reports/export/list`;

export const JOB_BULK_REPORTS_STATUS = `${BASE_URL}/job/bulk-reports`;

export const DOWNLOAD_COMPLETED_BULK_REPORTS = `${BASE_URL}/job/bulk-reports`;

export const BULK_REPORTS = `${BASE_URL}/job/bulk-reports`
export const EXPORT_PAYMENT_LIST = `${BASE_URL}/admin/dashboard/payment-status/export`

